<script>
    export default {
        components: {},
        props: {
            id: {
                type: Number,
                default: 0,
            }
        },
        data() {
            return {
                selected: 1
            };
        },
        computed: {
        },
        created: () => {
        },
        methods: {
            cleanDetail(){
                this.selected = 0;
            },
            setSelected(selected) {
                this.selected = selected;
            },
        },
        mounted() {
        }
    }
</script>

<template>

    <b-modal 
        id="newCategory" 
        centered
        hide-footer="true"
        hide-header="true"
        size="md"
        >
        
        <div class="row">
            <div class="col-md-12">
                <br/>
                <h3 class="pedido-welly-text text-center">
                    <b>Agrega tu categoría</b>
                </h3> 
                <h4 class="pedido-welly-text text-center">
                    Por favor ingresa tu nueva categoría, asegurate de no haberla agregado anteriormente.
                </h4> 
            </div>
        </div>

        <br/>

        <div class="row">
            <div class="col-md-12">
                <b-form-input v-model="name" type="text" placeholder="Escribe tu categoría"></b-form-input>
            </div>
        </div>

        <br/>

        <div class="row">
            <div class="col-md-6" @click="setSelected(1)">
                <div class="category-container">
                    <div class="category-container-padding">
                        <span class="pedido-welly-text">
                            Categoría A
                        </span> 
                        <br/>
                    </div>
                </div>
            </div>
            <div class="col-md-6" @click="setSelected(2)">
                <div class="category-container">
                    <div class="category-container-padding">
                        <span class="pedido-welly-text">
                            Categoría B
                        </span> 
                        <br/>
                    </div>
                </div>
            </div>
        </div>

        <br/><br/><br/>

        <div class="row">
            <div class="col-md-12">
                <div class="right">
                    <b-button href="#" type="submit" variant="primary" v-on:click="openMyResto" class="btn-primary">
                        Volver
                    </b-button>
                    <b-button href="#" type="submit" variant="success" v-on:click="openMyResto" class="btn-success">
                        Agregar
                    </b-button>
                </div>
            </div>
        </div>


        <template v-slot:modal-footer>
            <b-button variant="secondary" @click="showModal = false;"
                >Close</b-button
            >
        </template>
    </b-modal>
    
</template>
